// assets
import unknownCoinSrc from '@/assets/images/coins/UNKNOWN.svg';

import btcCoinSrc from '@/assets/images/coins/BTC.svg';
import ltcCoinSrc from '@/assets/images/coins/LTC.svg';
import bchCoinSrc from '@/assets/images/coins/BCH.svg';
import bsvCoinSrc from '@/assets/images/coins/BSV.svg';
import dogeCoinSrc from '@/assets/images/coins/DOGE.svg';

import ethCoinSrc from '@/assets/images/coins/ETH.svg';
import etcCoinSrc from '@/assets/images/coins/ETC.svg';
import bnbCoinSrc from '@/assets/images/coins/BNB.svg';
import maticCoinSrc from '@/assets/images/coins/MATIC.svg';
import avaxCoinSrc from '@/assets/images/coins/AVAX.svg';
import arbCoinSrc from '@/assets/images/coins/ARB.svg';

import trxCoinSrc from '@/assets/images/coins/TRX.svg';
import algoCoinSrc from '@/assets/images/coins/ALGO.svg';
import adaCoinSrc from '@/assets/images/coins/ADA.svg';
import zecCoinSrc from '@/assets/images/coins/ZEC.svg';
import solCoinSrc from '@/assets/images/coins/SOL.svg';
import dotCoinSrc from '@/assets/images/coins/DOT.svg';

import xrpCoinSrc from '@/assets/images/coins/XRP.svg';
import xlmCoinSrc from '@/assets/images/coins/XLM.svg';

import usdtCoinSrc from '@/assets/images/coins/USDT.svg';
import usdcCoinSrc from '@/assets/images/coins/USDC.svg';
import daiCoinSrc from '@/assets/images/coins/DAI.svg';

import linkCoinSrc from '@/assets/images/coins/LINK.svg';
import aaveCoinSrc from '@/assets/images/coins/AAVE.svg';
import nearCoinSrc from '@/assets/images/coins/NEAR.svg';

import USDTERC20CoinSrc from '@/assets/images/coins/USDTERC20.svg';
import USDTTRC20CoinSrc from '@/assets/images/coins/USDTTRC20.svg';
import BTGCoinSrc from '@/assets/images/coins/BTG.svg';
import XVGCoinSrc from '@/assets/images/coins/XVG.svg';
import QTUMCoinSrc from '@/assets/images/coins/QTUM.svg';
import KMDCoinSrc from '@/assets/images/coins/KMD.svg';
import BATCoinSrc from '@/assets/images/coins/BAT.svg';
import WAVESCoinSrc from '@/assets/images/coins/WAVES.svg';
import TUSDCoinSrc from '@/assets/images/coins/TUSD.svg';
import ZENCoinSrc from '@/assets/images/coins/ZEN.svg';
import FUNCoinSrc from '@/assets/images/coins/FUN.svg';
import RVNCoinSrc from '@/assets/images/coins/RVN.svg';
import BELCoinSrc from '@/assets/images/coins/BEL.svg';
import ZILCoinSrc from '@/assets/images/coins/ZIL.svg';

import cardSrc from '@/assets/images/cards/card.svg';

// chains
import unknownChainSrc from '@/assets/images/chains/UNKNOWN.svg';

import btcChainSrc from '@/assets/images/chains/BTC.svg';
import ltcChainSrc from '@/assets/images/chains/LTC.svg';
import bchChainSrc from '@/assets/images/chains/BCH.svg';
import bsvChainSrc from '@/assets/images/chains/BSV.svg';
import dogeChainSrc from '@/assets/images/chains/DOGE.svg';
import omniUSDTChainSrc from '@/assets/images/chains/OMNI.svg';

import ethChainSrc from '@/assets/images/chains/ETH.svg';
import etcChainSrc from '@/assets/images/chains/ETC.svg';
import bscChainSrc from '@/assets/images/chains/BSC.svg';
import maticChainSrc from '@/assets/images/chains/MATIC.svg';
import avaxChainSrc from '@/assets/images/chains/AVAX.svg';
import arbChainSrc from '@/assets/images/chains/ARB.svg';
import opChainSrc from '@/assets/images/chains/OP.svg';
import baseChainSrc from '@/assets/images/chains/BASE.svg';
import celoChainSrc from '@/assets/images/chains/CELO.svg';

import trxChainSrc from '@/assets/images/chains/TRX.svg';
import algoChainSrc from '@/assets/images/chains/ALGO.svg';
import adaChainSrc from '@/assets/images/chains/ADA.svg';
import zecChainSrc from '@/assets/images/chains/ZEC.svg';
import solChainSrc from '@/assets/images/chains/SOL.svg';
import dotChainSrc from '@/assets/images/chains/DOT.svg';

import xrpChainSrc from '@/assets/images/chains/XRP.svg';
import xlmChainSrc from '@/assets/images/chains/XLM.svg';
import tonChainSrc from '@/assets/images/chains/TON.svg';
import nearChainSrc from '@/assets/images/chains/NEAR.svg';
import tezosCoinSrc from '@/assets/images/chains/XTZ.svg';
import aptosCoinSrc from '@/assets/images/chains/APT.svg';

import { AssetsEnum } from './assets';
import { ChainsEnum } from './chains';

const UNKNOWN_KEY = 'UNKNOWN';

const ASSET_ICONS: Record<string, string> = {
  [UNKNOWN_KEY]: unknownCoinSrc,
  //
  [AssetsEnum.BTC]: btcCoinSrc,
  [AssetsEnum.LTC]: ltcCoinSrc,
  [AssetsEnum.BCH]: bchCoinSrc,
  [AssetsEnum.BSV]: bsvCoinSrc,
  [AssetsEnum.DOGE]: dogeCoinSrc,
  [ChainsEnum.TETHER_OMNI]: omniUSDTChainSrc,
  //
  [AssetsEnum.ETH]: ethCoinSrc,
  [AssetsEnum.ETC]: etcCoinSrc,
  [AssetsEnum.BNB]: bnbCoinSrc,
  [AssetsEnum.BSC]: bnbCoinSrc,
  [AssetsEnum.MATIC]: maticCoinSrc,
  [ChainsEnum.POLYGON]: maticChainSrc,
  [AssetsEnum.AVAX]: avaxCoinSrc,
  [AssetsEnum.ARB]: arbCoinSrc,
  [AssetsEnum.OP]: opChainSrc,
  [AssetsEnum.BASE]: baseChainSrc,
  [AssetsEnum.CELO]: celoChainSrc,
  //
  [AssetsEnum.TRX]: trxCoinSrc,
  [AssetsEnum.ALGO]: algoCoinSrc,
  [AssetsEnum.ADA]: adaCoinSrc,
  [AssetsEnum.ZEC]: zecCoinSrc,
  [AssetsEnum.SOL]: solCoinSrc,
  [AssetsEnum.DOT]: dotCoinSrc,
  //
  [AssetsEnum.XRP]: xrpCoinSrc,
  [AssetsEnum.XLM]: xlmCoinSrc,
  //
  [AssetsEnum.USDT]: usdtCoinSrc,
  [AssetsEnum.USDC]: usdcCoinSrc,
  [AssetsEnum.DAI]: daiCoinSrc,
  //
  [AssetsEnum.LINK]: linkCoinSrc,
  [AssetsEnum.AAVE]: aaveCoinSrc,
  [AssetsEnum.NEAR]: nearCoinSrc,
  [AssetsEnum.XTZ]: tezosCoinSrc,
  [ChainsEnum.TON]: tonChainSrc,
  [ChainsEnum.APT]: aptosCoinSrc,
  //
  [AssetsEnum.USD]: cardSrc,
  [AssetsEnum.USDTERC20]: USDTERC20CoinSrc,
  [AssetsEnum.USDTTRC20]: USDTTRC20CoinSrc,
  [AssetsEnum.BTG]: BTGCoinSrc,
  [AssetsEnum.XVG]: XVGCoinSrc,
  [AssetsEnum.QTUM]: QTUMCoinSrc,
  [AssetsEnum.KMD]: KMDCoinSrc,
  [AssetsEnum.BAT]: BATCoinSrc,
  [AssetsEnum.WAVES]: WAVESCoinSrc,
  [AssetsEnum.TUSD]: TUSDCoinSrc,
  [AssetsEnum.ZEN]: ZENCoinSrc,
  [AssetsEnum.FUN]: FUNCoinSrc,
  [AssetsEnum.RVN]: RVNCoinSrc,
  [AssetsEnum.BEL]: BELCoinSrc,
  [AssetsEnum.ZIL]: ZILCoinSrc,
};

const NETOWRK_ICONS: Record<string, string> = {
  [UNKNOWN_KEY]: unknownChainSrc,
  //
  [ChainsEnum.BTC]: btcChainSrc,
  [ChainsEnum.LTC]: ltcChainSrc,
  [ChainsEnum.BCH]: bchChainSrc,
  [ChainsEnum.BSV]: bsvChainSrc,
  [ChainsEnum.DOGE]: dogeChainSrc,
  [ChainsEnum.TETHER_OMNI]: omniUSDTChainSrc,
  //
  [ChainsEnum.ETH]: ethChainSrc,
  [ChainsEnum.ETC]: etcChainSrc,
  [ChainsEnum.BSC]: bscChainSrc,
  [ChainsEnum.POLYGON]: maticChainSrc,
  [ChainsEnum.MATIC]: maticChainSrc,
  [ChainsEnum.AVAX]: avaxChainSrc,
  [ChainsEnum.ARB]: arbChainSrc,
  [ChainsEnum.OP]: opChainSrc,
  [ChainsEnum.BASE]: baseChainSrc,
  [ChainsEnum.CELO]: celoChainSrc,
  //
  [ChainsEnum.TRX]: trxChainSrc,
  [AssetsEnum.ALGO]: algoChainSrc,
  [ChainsEnum.ADA]: adaChainSrc,
  [ChainsEnum.ZEC]: zecChainSrc,
  [ChainsEnum.SOL]: solChainSrc,
  [ChainsEnum.DOT]: dotChainSrc,
  //
  [ChainsEnum.XRP]: xrpChainSrc,
  [ChainsEnum.XLM]: xlmChainSrc,
  [ChainsEnum.TON]: tonChainSrc,
  [ChainsEnum.NEAR]: nearChainSrc,
  [ChainsEnum.XTZ]: tezosCoinSrc,
  [ChainsEnum.APT]: aptosCoinSrc,
};

export { UNKNOWN_KEY, ASSET_ICONS, NETOWRK_ICONS };
